import { jsx as n } from "react/jsx-runtime";
import i from "../../utils/classNames.js";
import { AppMenuDropdown as u } from "./AppMenuDropdown.js";
import c from "./AppMenuContent.js";
const f = (s) => {
  const {
    label: t = "Unknown",
    appMenuItems: o = [],
    appNavigatorClassName: p,
    appNavigator: e,
    onToggleAppMenu: r,
    ...l
  } = s, a = !!(o?.length || e), m = i(
    "ModuleNavigation AppMenu",
    "user-select-none",
    a && "hasModules",
    !e && "pointer-events-none",
    p && p
  );
  return /* @__PURE__ */ n("ul", { ...l, className: m, children: /* @__PURE__ */ n(u, { title: t, caret: a, onToggleAppMenu: r, children: e && /* @__PURE__ */ n(c, { appMenuItems: o, appNavigator: e }) }) });
};
export {
  f as default
};
//# sourceMappingURL=AppMenu.js.map
